const toggleArrayItem = <T>(array: T[] = [], value: T | undefined = undefined): T[] => {
  if (!Array.isArray(array)) return [];
  if (!value) return array;

  if (array.includes(value)) {
    return array.filter(item => item !== value);
  }
  return [...array, value];
};

export default toggleArrayItem;
